(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const storagePrefix = 'aogeo-filter-v48:';
  let scheduled = false;

  const storageKey = (label) =>
    storagePrefix + window.location.pathname + ':' + label.toLowerCase();

  const readPreference = (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  };

  const writePreference = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch {}
  };

  const setupPanels = () => {
    scheduled = false;
    if (!desktop.matches) return;

    document
      .querySelectorAll(
        '.product-grid-container .facets-block-wrapper--vertical:not(#filters-drawer) .facets__panel'
      )
      .forEach((panel, index) => {
        const label = (panel.querySelector('.facets__label')?.textContent || '').replace(/\s+/g, ' ').trim();
        if (!label) return;

        const key = storageKey(label);
        const preference = readPreference(key);
        const hasActiveValue = Boolean(
          panel.querySelector('input[type="checkbox"]:checked, input[type="radio"]:checked')
        );

        if (hasActiveValue) panel.open = true;
        else if (preference !== null) panel.open = preference === '1';
        else panel.open = index < 2;

        if (panel.dataset.aogeoV48Bound === 'true') return;
        panel.dataset.aogeoV48Bound = 'true';
        panel.addEventListener('toggle', () => {
          writePreference(key, panel.open ? '1' : '0');
        });
      });
  };

  const scheduleSetup = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(setupPanels);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupPanels, { once: true });
  } else {
    setupPanels();
  }

  desktop.addEventListener('change', scheduleSetup);
  document.addEventListener('shopify:section:load', scheduleSetup);

  new MutationObserver(scheduleSetup).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/* Aogeo V49 — runtime two-column grid guard */
(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  let frame = 0;

  const applyGrid = () => {
    frame = 0;
    document
      .querySelectorAll('.product-grid-container .collection-wrapper.apf-collection-wrapper')
      .forEach((wrapper) => {
        const hasDesktopSidebar = wrapper.querySelector(
          ':scope > .facets-block-wrapper--vertical:not(#filters-drawer)'
        );
        if (desktop.matches && hasDesktopSidebar) {
          wrapper.style.setProperty('grid-template-areas', 'none', 'important');
          wrapper.style.setProperty(
            'grid-template-columns',
            '270px minmax(0, 1fr)',
            'important'
          );
        } else {
          wrapper.style.removeProperty('grid-template-areas');
          wrapper.style.removeProperty('grid-template-columns');
        }
      });
  };

  const schedule = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(applyGrid);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyGrid, { once: true });
  } else {
    applyGrid();
  }

  desktop.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
